import type { Maybe } from "graphql/jsutils/Maybe";

import type { Call } from "@/states/call/call.utility.decl";

export function getRevieweeUserId(call?: Maybe<Call>) {
  if (!call) {
    return undefined;
  }

  if (call.direction === "inbound") {
    return call.to?.agentId;
  }

  if (call.direction === "outbound") {
    return call.from?.agentId;
  }
}
